import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    deficiencyCommentsOuterGrid: {
      '& .deficiencyCommentsInnerGrid': {
        margin: '16px 0px',
        '& .deficiencyCardContainer': {
          margin: '8px 16px 22px',
          padding: '24px 24px 22px',
          '& .deficiencyInspectorComment': {
            borderRadius: '4px',
          },
          '& .previousCmts': {
            paddingBottom: '5px',
            color: 'rgba(239, 239, 239, 0.5)',
            marginTop: '10px',
          },
          '& .commentDate': {
            marginTop: '16px',
          },
        },
      },
    },
    defCommentsActionGrid: {
      padding: '16px 16px 8px',
      '& .commentSaveButton': {
        borderRadius: '4px',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
      },
      '& .showSaveButton': {
        display: 'block',
        borderRadius: '4px',
        backgroundColor: 'rgba(255, 255, 255, 0.4) !important',
      },
      '& .hideSaveButton': {
        display: 'none',
      },
      '& .saveButton': { borderRadius: '4px', backgroundColor: '' },
    },
    cancelButtonGrid: {
      marginRight: '4px',
      '& .cancelBtn': {
        border: '1px solid rgba(42, 171, 63, 1)',
      },
      '& .deficiencyInspectorCommentButton': {
        borderRadius: '4px',
      },
      '& .commentsCancelButton': {
        border: '3px solid rgba(42, 171, 63, 1)',
        borderRadius: '4px',
        height: 44,
      },
      '& .showSaveButton': {
        borderRadius: '4px',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
      },
      '& .disableSaveButton': {
        borderRadius: '4px',
      },
    },
    hideCancelButton: {
      display: 'none',
    },
    hideSaveButton: {
      display: 'none',
    },
    submitInspectionText: {
      letterSpacing: '1.25px',
      color: 'black',
    },
    deficiencyCommentsLabel: {
      paddingBottom: '5px',
    },
    deficiencyLeadCommentsTextField: {
      borderRadius: '4px',
      height: '100px',
    },
    checkBoxText: {
      flex: 'inherit',
      marginLeft: '24px',
      marginTop: '-4px',
    },
    subtitle: {
      color: '#707070',
      fontStyle: 'normal',
      lineHeight: '20px',
    },
  }),
);

export default useStyles;
